export default new URL("../images/places/place-1.jpg", import.meta.url).href;